var stickyCart = {};
var isOnScreen = require('../util/isOnScreen');
stickyCart.init = function () {
  // const productInfo = $('section.selected-product');
  var stickyCartMainWrap = $('.js-sticky-cart-main');
  window.addEventListener('scroll', function (e) {
    if (stickyCartMainWrap.length) {
      if (isOnScreen(stickyCartMainWrap)) {
        $('body').removeClass('is-showingSticky');
      } else {
        $('body').addClass('is-showingSticky');
      }
    }
  });
};
stickyCart.init();
window.stickyCart = stickyCart;


// WEBPACK FOOTER //
// ./scripts/components/sticky-cart.js